// TODO : Same tracking as mobile app (except for the mobile specifics ones). Not everything is used for the moment.
export const TrackedActions = {
  Messages: {
    createMessage: 'Create discussion message',
  },
  Claims: {
    createClaim: 'Create claim',
    closeClaim: 'Close invoice',
  },
  Clicks: {
    clickDocument: 'Click document',
    clickPhone: 'Click phone icon',
    clickPhoneTopic: 'Click phone topic',
    clickExternalLink: 'Click external link',
  },
  Sms: {
    smsSent: 'Sms sent',
    smsCancelled: 'Sms cancelled',
    smsFailed: 'Sms failed',
  },
  Trades: {
    tradeSubscription: 'Subscribe to trade',
    updateTradeSubscription: 'Update subscribed trade',
    createTradeRequirementInstance: 'Create trade requirement instance',
    updateTradeRequirementInstance: 'Update trade requirement instance',
    createPharmacyTrade: 'Create pharmacy trade',
    acceptTradesInstance: 'Accept trades instance',
    refuseTradesInstance: 'Refuse trades instance',
    exportTradesInstances: 'Export trades instances',
    refusedTrade: 'Refused trade',
    cancelTradeRefusal: 'Cancel trade refusal',
    cancelSubscription: 'Cancel subscription',
    pharmacistAddCommentToTradesInstance: 'Commented report',
    groupSendMessage: 'Group send message on lab trade',
    groupAcceptTrade: 'Group accept lab trade',
    groupRefuseTrade: 'Group refuse lab trade',
    exportTradePlan: 'Export trade plan',
    exportTradePlanForLab: 'Export trade plan for lab',
  },
  Campaign: {
    createCampaign: 'Create campaign',
    postCampaignResponse: 'Respond to campaign',
  },
  SalesRep: {
    addPharmacyToSalesRep: 'Add pharmacy to sales rep',
    removePharmacyFromSalesRep: 'Remove pharmacy from sales rep',
  },
  Onboarding: {
    createProfile: 'Create profile',
    joinPharmacy: 'Join pharmacy',
    createPharmacy: 'Create pharmacy',
  },
  Pharmacy: {
    updatePharmacistRole: 'Update pharmacist role',
    addUserOnPharmacy: 'Add user on pharmacy',
  },
  PharmacyLabPage: {
    viewedLabPage: {
      HomeTab: 'Viewed lab page - Home tab',
      TradesTab: 'Viewed lab page - Trades tab',
      ClaimsTab: 'Viewed lab page - Claims tab',
      AppointmentNotesTab: 'Viewed lab page - Appointment notes tab',
      ChatTab: 'Viewed lab page - Chat tab',
      DocumentsTab: 'Viewed lab page - Documents tab',
    },
    actions: {
      appointmentNotes: {
        created: 'Created appointment note',
        updated: 'Updated appointment note',
        deleted: 'Deleted appointment note',
      },
      documents: {
        created: 'Created document',
        deleted: 'Deleted document',
        viewed: 'Viewed document',
      },
      mainNote: {
        updated: 'Updated main note',
      },
      FAQ: {
        viewed: 'Viewed FAQ',
      },
      groupPartnership: {
        viewed: 'Viewed Lab/Group partnership',
      },
      trades: {
        created: 'Created pharmacy trade',
      },
    },
  },
  User: {
    editProfile: 'Edit profile',
  },
  Boost: {
    navigateToBoost: 'Navigate to boost',
    showBoostConsentModal: 'Show boost consent modal',
  },
  Other: {
    addLabToPartners: 'Add lab to partners',
    callLab: 'Call lab support',
    openPharmacyTradeModal: 'Open pharmacy trade modal',
    uploadFile: 'Upload file',
    intercomFAQ: 'Intercom FAQ',
    labTakeAppointment: 'Lab take appointment',
    navigate: 'Navigate',
    downloadExport: 'Download export',
  },
  Konnect: {
    goToSetup: 'Clicked on go to setup button',
    completedSetupFromTradesBanner: 'Completed Konnect setup from trades banner',
    clickedBookDemoFromEncoding: 'Clicked book Konnect demo from encoding modal',
    clickedContactDemoFromSettings: 'Clicked contact for Konnect demo from settings banner',
  },
} as const;

type DeepValues<T> = T extends object
  ? T extends string
    ? T
    : { [K in keyof T]: DeepValues<T[K]> }[keyof T]
  : T;

export type TrackedActionsType = DeepValues<typeof TrackedActions>;
